// extracted by mini-css-extract-plugin
export default {"field":"Vehicles_field__WvnOM","accordionContainer":"Vehicles_accordionContainer__Z0M9n"};